import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import styled from 'src/ui/library/styled';
import classNames from 'classnames';
import intl from 'react-intl-universal';

const styles = (theme, props) => ({
  root: {},
  formControl: {
    display: 'flex',
  },
  formControlLabel: {
    position: 'relative',
    left: '-5px',
    fontSize: '1rem',
  },
  checkbox: {
    color: theme.colors.eyConfidentGrey,
  },
  checked: {
    color: `${theme.colors.eyConfidentGrey} !important`,
  },
  hasError: {
    color: `${theme.colors.red} !important`,
  },
});

class CheckboxBase extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override CheckboxBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Checkbox> */
    className: PropTypes.string,
    /** Value of `input` element */
    value: PropTypes.string,
    /** Text used for input label */
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
    /** If `true`, the label is displayed as required. */
    required: PropTypes.any,
    /** Callback fired when value is changed */
    onChange: PropTypes.func,

    hasError: PropTypes.bool,
  };

  static defaultProps = {
    styles: {},
    required: false,
    className: '',
    hasError: false,
  };

  state = {
    checked: this.props.value || false,
    isDisabled: this.props.readOnly,
  };

  handleChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }
    //if lockAfterValueChange prop is true , then disable field on change
    const isDisabled = this.props.lockAfterValueChange ? true : this.state.isDisabled;
    this.setState({
      checked: event.target.checked,
      isDisabled,
    });
  };

  render() {
    const { classes, label, required, hasError } = this.props;
    let checked = typeof this.props.checked === 'boolean' ? this.props.checked : this.props.checked.toLowerCase() === 'true' ? true : false;
    const formControlClass = classNames({
      [classes.formControl]: true,
    });
    const checkBoxClass = classNames({
      [classes.hasError]: hasError,
    });

    const checkboxComponent = (
      <Checkbox
        checked={checked}
        classes={{
          root: classes.root,
          checked: classes.checked,
        }}
        className={checkBoxClass}
        onChange={this.handleChange}
        disabled={this.state.isDisabled}
      />
    );

    const labelRequiredComponent = (
      <span>
        {label}
        <span>{intl.get('questionnaire.requiredLabel')}</span>
      </span>
    );

    return (
      <FormControl component="fieldset" className={formControlClass}>
        {label ? (
          <FormControlLabel
            control={checkboxComponent}
            classes={{ label: classes.formControlLabel }}
            label={required ? labelRequiredComponent : label}
          />
        ) : (
          checkboxComponent
        )}
      </FormControl>
    );
  }
}

export { CheckboxBase };
export default styled(CheckboxBase)(styles);
